import React from "react"
import _ from "lodash"
import PaginationStyle from "./PaginationStyle.module.css"
import AnchorLink from "react-anchor-link-smooth-scroll"

const Pagination = ({
  itemsCount,
  pageSize,
  onPageChange,
  currentPage,
  paginationNextPage,
  paginationPrevPage,
  goToFirstPage,
  goToLastPage,
}) => {
  const pagesCount = Math.ceil(itemsCount / pageSize)
  if (pagesCount === 1) return null
  const pages = _.range(1, pagesCount + 1)
  return (
    <div className={PaginationStyle.paginate_holder}>
      <span className={PaginationStyle.pagination_info}>
        {currentPage}-{pagesCount} от {itemsCount}
      </span>
      <div className={PaginationStyle.holder}>
        <div
          role="button"
          tabIndex={0}
          onKeyDown={goToFirstPage}
          className={
            currentPage === 1
              ? PaginationStyle.no_prev
              : PaginationStyle.go_to_first_page
          }
          onClick={goToFirstPage}
        >
          <svg
            aria-hidden="true"
            focusable="false"
            data-prefix="fal"
            data-icon="arrow-to-left"
            className="svg-inline--fa fa-arrow-to-left fa-w-14"
            role="img"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 448 512"
          >
            <path
              fill="currentColor"
              d="M216 412.5l-148.5-148c-4.7-4.7-4.7-12.3 0-17L216 99.5c4.7-4.7 12.3-4.7 17 0l7.1 7.1c4.7 4.7 4.7 12.3 0 17L124.1 239H436c6.6 0 12 5.4 12 12v10c0 6.6-5.4 12-12 12H124.1L240 388.4c4.7 4.7 4.7 12.3 0 17l-7.1 7.1c-4.6 4.7-12.2 4.7-16.9 0zM12 448h8c6.6 0 12-5.4 12-12V76c0-6.6-5.4-12-12-12h-8C5.4 64 0 69.4 0 76v360c0 6.6 5.4 12 12 12z"
            />
          </svg>
        </div>
        <AnchorLink
          href="#table"
          role="button"
          tabIndex={0}
          onKeyDown={paginationPrevPage}
          onClick={paginationPrevPage}
          className={
            currentPage === 1
              ? PaginationStyle.no_prev
              : PaginationStyle.prev_arrow
          }
        >
          <svg
            aria-hidden="true"
            focusable="false"
            data-prefix="fal"
            data-icon="chevron-left"
            className="svg-inline--fa fa-chevron-left fa-w-8"
            role="img"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 256 512"
          >
            <path
              fill="currentColor"
              d="M238.475 475.535l7.071-7.07c4.686-4.686 4.686-12.284 0-16.971L50.053 256 245.546 60.506c4.686-4.686 4.686-12.284 0-16.971l-7.071-7.07c-4.686-4.686-12.284-4.686-16.97 0L10.454 247.515c-4.686 4.686-4.686 12.284 0 16.971l211.051 211.05c4.686 4.686 12.284 4.686 16.97-.001z"
            />
          </svg>
        </AnchorLink>
        <nav>
          <ul>
            {pages.map(page => {
              if (
                page === 1 ||
                page === pageSize ||
                (page >= currentPage - 2 && page <= currentPage + 2)
              )
                return (
                  <li
                    key={page}
                    className={
                      page === currentPage
                        ? PaginationStyle.active_page
                        : PaginationStyle.page
                    }
                  >
                    <AnchorLink
                      role="button"
                      tabIndex={0}
                      onKeyDown={() => onPageChange(page)}
                      href="#table"
                      className={PaginationStyle.page}
                      onClick={() => onPageChange(page)}
                    >
                      {page}
                    </AnchorLink>
                  </li>
                )
              return null
            })}
          </ul>
        </nav>
        <p
          className={
            currentPage >= pagesCount - 2
              ? PaginationStyle.display_none
              : PaginationStyle.display
          }
        >
          <span>...</span>
          {pagesCount}
        </p>
        <AnchorLink
          role="button"
          tabIndex={0}
          onKeyDown={paginationNextPage}
          href="#table"
          onClick={paginationNextPage}
          className={
            currentPage === pagesCount
              ? PaginationStyle.no_next
              : PaginationStyle.next_arrow
          }
        >
          <svg
            aria-hidden="true"
            focusable="false"
            data-prefix="fal"
            data-icon="chevron-right"
            className="svg-inline--fa fa-chevron-right fa-w-8"
            role="img"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 256 512"
          >
            <path
              fill="currentColor"
              d="M17.525 36.465l-7.071 7.07c-4.686 4.686-4.686 12.284 0 16.971L205.947 256 10.454 451.494c-4.686 4.686-4.686 12.284 0 16.971l7.071 7.07c4.686 4.686 12.284 4.686 16.97 0l211.051-211.05c4.686-4.686 4.686-12.284 0-16.971L34.495 36.465c-4.686-4.687-12.284-4.687-16.97 0z"
            />
          </svg>
        </AnchorLink>
        <div
          role="button"
          tabIndex={0}
          onKeyDown={() => goToLastPage(pagesCount)}
          className={
            currentPage === pagesCount
              ? PaginationStyle.no_next
              : PaginationStyle.go_to_last_page
          }
          onClick={() => goToLastPage(pagesCount)}
        >
          <svg
            aria-hidden="true"
            focusable="false"
            data-prefix="fal"
            data-icon="arrow-to-right"
            className="svg-inline--fa fa-arrow-to-right fa-w-14"
            role="img"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 448 512"
          >
            <path
              fill="currentColor"
              d="M215 99.5l-7.1 7.1c-4.7 4.7-4.7 12.3 0 17l116 115.4H12c-6.6 0-12 5.4-12 12v10c0 6.6 5.4 12 12 12h311.9L208 388.4c-4.7 4.7-4.7 12.3 0 17l7.1 7.1c4.7 4.7 12.3 4.7 17 0l148.5-148c4.7-4.7 4.7-12.3 0-17L232 99.5c-4.7-4.7-12.3-4.7-17 0zM448 76v360c0 6.6-5.4 12-12 12h-8c-6.6 0-12-5.4-12-12V76c0-6.6 5.4-12 12-12h8c6.6 0 12 5.4 12 12z"
            />
          </svg>
        </div>
      </div>
    </div>
  )
}

export default Pagination
